import { IController, IWindowService } from 'angular';
import { IStateService } from 'angular-ui-router';

export class PrepReviewCtrl implements IController {
  static $inject = ['$state', '$window'];

  constructor(private $state: IStateService, private $window: IWindowService) {}

  goToMasterProgram() {
    const url = this.$state.href(`main.school.settings.master-program`);
    this.$window.open(url, '_blank');
  }
}
